import { render, staticRenderFns } from "./MarketInvoicesTable.vue?vue&type=template&id=fe470bfa&"
import script from "./MarketInvoicesTable.vue?vue&type=script&lang=js&"
export * from "./MarketInvoicesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports